import React, { useMemo } from 'react';
import { selectConfigSettings } from '../../../../store/slices/config/configSelectors';
import {
  selectPaymentFees,
  selectSelectedPaymentMethod,
} from '../../../../store/slices/payment/paymentSelectors';
import { Text } from 'rsuite';
import {
  PresentationCol,
  PresentationGrid,
  PresentationRow,
} from '../../../layout/PresentationLayout';
import { useSelector } from 'react-redux';
import { convertNumberToCurrency } from '../../../../common/utils';
import {
  calculateProcessingFee,
  getProcessingFeeLabel,
  calculateTotalDue,
  isGeneric,
} from '../utils';

const PaymentSummary = () => {
  const settings = useSelector(selectConfigSettings);
  const processor = settings?.payment_processor;
  const isGenericProvider = useMemo(() => isGeneric(processor), [processor]);
  const paymentFees = useSelector(selectPaymentFees);
  const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);

  const totalDue = useMemo(
    () =>
      calculateTotalDue(selectedPaymentMethod, paymentFees, isGenericProvider),
    [selectedPaymentMethod, paymentFees, isGenericProvider]
  );

  const processingFee = useMemo(
    () =>
      calculateProcessingFee(
        selectedPaymentMethod,
        paymentFees,
        isGenericProvider
      ),
    [selectedPaymentMethod, paymentFees, isGenericProvider]
  );

  const processingFeeLabel = useMemo(
    () => getProcessingFeeLabel(selectedPaymentMethod),
    [selectedPaymentMethod]
  );

  return (
    <PresentationGrid
      fluid
      data-testid="payment-summary-component"
    >
      <PresentationRow>
        <PresentationCol
          xs={12}
          lg={24}
          className="mb-16"
        >
          <Text className="mb-8">Total Amount Due</Text>
          <Text className="header-text-h3 text-bold">
            {convertNumberToCurrency(totalDue)}
          </Text>
        </PresentationCol>
        <PresentationCol
          xs={12}
          lg={24}
        >
          <div>
            {paymentFees?.breakdown?.map((item, index) => (
              <PresentationRow
                key={index}
                className="mb-8"
              >
                <PresentationCol xs={24}>
                  <Text className="text-small">{item.label}</Text>
                  <Text>{convertNumberToCurrency(item.value)}</Text>
                </PresentationCol>
              </PresentationRow>
            ))}
            {!isGenericProvider && (
              <PresentationRow>
                <PresentationCol xs={24}>
                  <Text className="text-small">{processingFeeLabel}</Text>
                  <Text>{convertNumberToCurrency(processingFee)}</Text>
                </PresentationCol>
              </PresentationRow>
            )}
          </div>
        </PresentationCol>
      </PresentationRow>
    </PresentationGrid>
  );
};

export default PaymentSummary;
